/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x5042=['requires','RealTimeCollaborativeEditing','pluginName'];(function(_0x465c80,_0x5042f6){var _0x39a82d=function(_0x319c0e){while(--_0x319c0e){_0x465c80['push'](_0x465c80['shift']());}};_0x39a82d(++_0x5042f6);}(_0x5042,0x18b));var _0x39a8=function(_0x465c80,_0x5042f6){_0x465c80=_0x465c80-0x0;var _0x39a82d=_0x5042[_0x465c80];return _0x39a82d;};import{Plugin as _0x3e1c58}from'ckeditor5/src/core';import _0x4b3e49 from'./realtimecollaborativeediting/realtimecollaborationclient';export default class n extends _0x3e1c58{static get[_0x39a8('0x1')](){return[_0x4b3e49];}static get[_0x39a8('0x0')](){return _0x39a8('0x2');}}